define("shared/models/fb-post", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class DynamoFbPost extends _object.default {
    constructor(attrs) {
      const attrsCopy = {
        ...attrs
      };
      super();
      _defineProperty(this, "id", void 0);
      _defineProperty(this, "pageId", void 0);
      _defineProperty(this, "isPopular", void 0);
      _defineProperty(this, "isPublished", void 0);
      _defineProperty(this, "isHidden", void 0);
      _defineProperty(this, "isExpired", void 0);
      _defineProperty(this, "message", void 0);
      _defineProperty(this, "createdTime", void 0);
      _defineProperty(this, "updatedTime", void 0);
      _defineProperty(this, "updatedAt", void 0);
      _defineProperty(this, "permalinkUrl", void 0);
      _defineProperty(this, "fullPicture", void 0);
      _defineProperty(this, "timelineVisibility", void 0);
      _defineProperty(this, "properties", void 0);
      _defineProperty(this, "statusType", void 0);
      _defineProperty(this, "type", void 0);
      _defineProperty(this, "privacy", void 0);
      _defineProperty(this, "imageUrl", void 0);
      _defineProperty(this, "isVideo", void 0);
      _defineProperty(this, "ineligibleForInsights", void 0);
      _defineProperty(this, "impressions", void 0);
      _defineProperty(this, "reach", void 0);
      _defineProperty(this, "standardResUrl", void 0);
      _defineProperty(this, "clicks", void 0);
      _defineProperty(this, "likes", void 0);
      _defineProperty(this, "engagements", void 0);
      _defineProperty(this, "reactions", void 0);
      _defineProperty(this, "reactionsByType", void 0);
      _defineProperty(this, "videoViews", void 0);
      _defineProperty(this, "videoViewsUnique", void 0);
      _defineProperty(this, "comments", void 0);
      _defineProperty(this, "shares", void 0);
      _defineProperty(this, "socialProfile", void 0);
      _defineProperty(this, "scheduledPost", void 0);
      this.id = attrsCopy.id;
      this.pageId = attrsCopy.pageId;
      this.isPopular = attrsCopy.isPopular;
      this.isPublished = attrsCopy.isPublished;
      this.isHidden = attrsCopy.isHidden;
      this.isExpired = attrsCopy.isExpired;
      this.message = attrsCopy.message;
      this.createdTime = attrsCopy.createdTime;
      this.updatedTime = attrsCopy.updatedTime;
      this.updatedAt = attrsCopy.updatedAt;
      this.permalinkUrl = attrsCopy.permalinkUrl;
      this.fullPicture = attrsCopy.fullPicture;
      this.timelineVisibility = attrsCopy.timelineVisibility;
      this.properties = attrsCopy.properties;
      this.statusType = attrsCopy.statusType;
      this.type = attrsCopy.type;
      this.privacy = attrsCopy.privacy;
      this.imageUrl = attrsCopy.imageUrl;
      this.isVideo = attrsCopy.isVideo;
      this.standardResUrl = attrsCopy.standardResUrl;
      this.ineligibleForInsights = attrsCopy.ineligibleForInsights;
      this.impressions = attrsCopy.impressions;
      this.reach = attrsCopy.reach;
      this.clicks = attrsCopy.clicks;
      this.likes = attrsCopy.likes;
      this.engagements = attrsCopy.engagements;
      this.reactions = attrsCopy.reactions;
      this.reactionsByType = attrsCopy.reactionsByType;
      this.videoViews = attrsCopy.videoViews;
      this.videoViewsUnique = attrsCopy.videoViewsUnique;
      this.comments = attrsCopy.comments;
      this.shares = attrsCopy.shares;
      this.socialProfile = attrsCopy.socialProfile;
      this.scheduledPost = attrs.scheduledPost;
    }
  }
  _exports.default = DynamoFbPost;
});